import { useState } from 'react'
import { apiEtapa5 } from '../api'
import Aviso from '../../components/Aviso'
import { moeda, pct } from '../../components/format'
import { Campo, Cards, Gravado, Recibo, dataBR } from '../../etapa2/componentes'

const TIPOS = [
  ['JUSTA_CAUSA', 'Dispensa por justa causa'],
  ['TERMINO_CONTRATO_PRAZO', 'Término do contrato de experiência ou a prazo'],
  ['ANTECIPADA_EMPREGADOR', 'Rescisão antecipada pelo empregador (art. 479)'],
  ['ANTECIPADA_EMPREGADO', 'Rescisão antecipada pelo empregado (art. 480)'],
  ['RESCISAO_INDIRETA', 'Rescisão indireta (art. 483)'],
  ['FALECIMENTO', 'Falecimento do empregado'],
]
const COM_TERMINO = ['ANTECIPADA_EMPREGADOR', 'ANTECIPADA_EMPREGADO']

export default function RescisaoOutrosTipos({ empresaId }) {
  const [f, setF] = useState({
    funcionario_id: 'F1', nome: '', dependentes_irrf: 0, tipo: 'JUSTA_CAUSA', data_admissao: '', data_desligamento: '',
    data_termino_contrato: '', salario_base: '', media_variaveis: '0', periodos_ferias_vencidas: 0, periodos_ferias_em_dobro: 0,
    faltas_periodo_aquisitivo_atual: 0, adiantamento_decimo_terceiro: '0', saldo_fgts: '0', prejuizo_art_480: '0', data_pagamento: '',
  })
  const [res, setRes] = useState(null)
  const [erro, setErro] = useState('')
  const [carregando, setCarregando] = useState(false)
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value })

  async function calcular(gravar) {
    setErro('')
    setCarregando(true)
    try {
      setRes(await apiEtapa5.rescisaoOutrosTipos({
        ...f,
        empresa_id: empresaId,
        dependentes_irrf: Number(f.dependentes_irrf) || 0,
        periodos_ferias_vencidas: Number(f.periodos_ferias_vencidas) || 0,
        periodos_ferias_em_dobro: Number(f.periodos_ferias_em_dobro) || 0,
        faltas_periodo_aquisitivo_atual: Number(f.faltas_periodo_aquisitivo_atual) || 0,
        data_termino_contrato: f.data_termino_contrato || null,
        data_pagamento: f.data_pagamento || null,
      }, gravar))
    } catch (e) {
      setErro(e.message)
      setRes(null)
    } finally {
      setCarregando(false)
    }
  }

  const r = res?.resultado
  return (
    <section>
      <h2>Outros tipos de rescisão</h2>
      <p className="fundamento">Sem justa causa, pedido de demissão e acordo continuam na aba Rescisão.</p>
      <div className="grade">
        <Campo rotulo="Tipo de rescisão">
          <select value={f.tipo} onChange={set('tipo')}>{TIPOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        </Campo>
        <Campo rotulo="Matrícula"><input value={f.funcionario_id} onChange={set('funcionario_id')} /></Campo>
        <Campo rotulo="Nome"><input value={f.nome} onChange={set('nome')} /></Campo>
        <Campo rotulo="Admissão"><input type="date" value={f.data_admissao} onChange={set('data_admissao')} /></Campo>
        <Campo rotulo="Último dia trabalhado"><input type="date" value={f.data_desligamento} onChange={set('data_desligamento')} /></Campo>
        {COM_TERMINO.includes(f.tipo) && (
          <Campo rotulo="Término previsto do contrato"><input type="date" value={f.data_termino_contrato} onChange={set('data_termino_contrato')} /></Campo>
        )}
        <Campo rotulo="Salário base"><input type="number" step="0.01" value={f.salario_base} onChange={set('salario_base')} /></Campo>
        <Campo rotulo="Média mensal de variáveis"><input type="number" step="0.01" value={f.media_variaveis} onChange={set('media_variaveis')} /></Campo>
        <Campo rotulo="Dependentes IRRF"><input type="number" min="0" value={f.dependentes_irrf} onChange={set('dependentes_irrf')} /></Campo>
        <Campo rotulo="Períodos de férias vencidas"><input type="number" min="0" max="2" value={f.periodos_ferias_vencidas} onChange={set('periodos_ferias_vencidas')} /></Campo>
        <Campo rotulo="Desses, em dobro"><input type="number" min="0" max="2" value={f.periodos_ferias_em_dobro} onChange={set('periodos_ferias_em_dobro')} /></Campo>
        <Campo rotulo="Faltas no período aquisitivo atual"><input type="number" min="0" value={f.faltas_periodo_aquisitivo_atual} onChange={set('faltas_periodo_aquisitivo_atual')} /></Campo>
        <Campo rotulo="Adiantamento de 13º já pago"><input type="number" step="0.01" value={f.adiantamento_decimo_terceiro} onChange={set('adiantamento_decimo_terceiro')} /></Campo>
        <Campo rotulo="Saldo FGTS (fins rescisórios)"><input type="number" step="0.01" value={f.saldo_fgts} onChange={set('saldo_fgts')} /></Campo>
        {f.tipo === 'ANTECIPADA_EMPREGADO' && (
          <Campo rotulo="Prejuízo comprovado (art. 480)"><input type="number" step="0.01" value={f.prejuizo_art_480} onChange={set('prejuizo_art_480')} /></Campo>
        )}
        <Campo rotulo="Data de pagamento"><input type="date" value={f.data_pagamento} onChange={set('data_pagamento')} /></Campo>
      </div>
      <div className="acoes">
        <button disabled={carregando || !empresaId} onClick={() => calcular(false)}>Calcular</button>
        <button className="secundario" disabled={carregando || !empresaId} onClick={() => calcular(true)}>Calcular e gravar</button>
      </div>
      <Aviso>{erro}</Aviso>
      {r && (
        <>
          <Gravado registroId={res.registro_id} />
          <Cards itens={[
            ['Líquido da rescisão', moeda(r.liquido), `Pagar até ${dataBR(r.data_limite_pagamento)}`],
            ['Aviso prévio indenizado', `${Number(r.dias_aviso_indenizado)} dias`, `projeção ${dataBR(r.data_projetada_aviso)}`],
            ['Multa FGTS', moeda(r.fgts.multa), `${pct(r.fgts.percentual_multa, 0)} de ${moeda(r.fgts.base_multa)}`],
            ['FGTS movimentável', r.fgts.saque_liberado ? moeda(r.fgts.valor_movimentavel_estimado) : 'Sem saque', r.descricao_tipo],
          ]} />
          <Recibo titulo="Termo de rescisão" resultado={r} />
        </>
      )}
    </section>
  )
}
